/**
 * EduWrite Student App — Design Tokens
 * Codified from the Tactile "Toybox" & C-P-A Design Standard.
 */

export const studentTheme = {
    colors: {
        sky: {
            top: '#4FB4F7',
            horizon: '#8FE2FF',
            beam: '#68CEFF',
            beamAlt: '#44A8EC',
        },
        meadow: {
            front: '#4CAF50',
            frontDark: '#388E3C',
            back: '#66BB6A',
            trees: '#2E7D32',
        },
        stage: {
            background: '#FFFFFF',
            border: 'rgba(255, 255, 255, 0.9)',
            shadow: 'rgba(15, 23, 42, 0.14)',
        },
        candy: {
            // Apple green hero button ("GO!")
            green: '#22C55E',
            greenBevel: '#15803D',
            greenHighlight: '#4ADE80',

            // Warm orange navigation ("Back")
            orange: '#FF9800',
            orangeBevel: '#D97706',
            orangeHighlight: '#FBBF24',

            // Sky blue tokens / buttons
            blue: '#3B82F6',
            blueBevel: '#1D4ED8',
            blueHighlight: '#60A5FA',

            // Sunshine yellow
            yellow: '#F59E0B',
            yellowBevel: '#B45309',
            yellowHighlight: '#FCD34D',

            // Coral / Ruby Red
            red: '#EF4444',
            redBevel: '#B91C1C',
            redHighlight: '#F87171',

            // Purple / Violet
            purple: '#8B5CF6',
            purpleBevel: '#6D28D9',
            purpleHighlight: '#A78BFA',
        },
        counter: {
            red: '#EF4444',
            redRing: '#DC2626',
            yellow: '#FBBF24',
            yellowRing: '#D97706',
            blue: '#3B82F6',
            blueRing: '#2563EB',
        },
        text: {
            dark: '#0F172A',
            muted: '#475569',
            light: '#FFFFFF',
            accentTeal: '#0D9488',
        },
    },
    radii: {
        stageCard: 32,
        stageCardMobile: 22,
        pill: 9999,
        round: 9999,
        tile: 16,
        card: 20,
    },
    bevel: {
        large: 5,
        medium: 4,
        small: 3,
    },
    touchTargets: {
        ks1: 72,
        ks2: 56,
        default: 64,
    },
};
